import script from "./ai-prompt-manager.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-prompt-manager.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__